export const RaterFormTypeConstants = {
  HO: 'HO',
  DP3: 'DP'
};
